export const ERROR_MAX_SIZE = (maxSize: number) => `File is too big. Max file size allowed is ${maxSize}`;
export const ERROR_ACCEPT =  `File's type is not allowed`;
